// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--1C-DW"};